<!-- eslint-disable -->
<template lang="pug">
        .settings(v-if='localSettings.length')
            template(v-for="(settings, index) in localSettings")
                divider(v-if="index > 0", :margin="'10px auto'")
                div
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_size') }}:
                        | {{ settings.difficult.name }}
                div(v-if='settings.image')
                        div {{ $i18n.t('trainer.trainer_gameFormSetting_image') }}:
                        img.image-preview(:src="settings.image")
                div(v-else)
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_imageNotSelected') }}
                div(v-if='settings.games && settings.games.length')
                        div
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_typeOfExamples') }}:
                                | {{ settings.games[0].name }}
                        div
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_gameParams') }}:
                                games-list(:games='settings.games', :user-id='userId', :in-browse-game="true")
                div(v-else)
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_typeOfExamplesNotSelected') }}
                div(v-if="settings.dueDate")
                    div
                        | {{ $i18n.t('homework.homework_create_executeTime') }}
                        | {{ getFormattedDate(settings.dueDate) }}
                slot
</template>

<script>
    /*eslint-disable*/
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'
    import getBase64FromUrl from '../../../utils/getBase64FromUrl'
    import {getFormattedDate} from "../../../utils/getFormattedDate";

    export default {
        mixins: [gamePreviewMixin, getBase64FromUrl],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework'
            },
            userId: Number,
        },
        components: {
            GamesList: () => ({
                component: new Promise(resolve => require(['../GamesList.vue'], resolve)),
            })
        },
        data() {
            return {
                localSettings: [],
            };
        },
        watch: {
            settings: {
                handler(val) {
                    this.localSettings = Array.isArray(val) ? val : [val];
                },
                immediate: true,
            }
        },
        created() {
          this.assignImage()
        },
        methods: {
            getFormattedDate,
            async assignImage() {
            if (this.settings.imageSrc) {
              this.settings.image = await this.getBase64ImageFromUrl(
                  this.$options.filters.apiFile(this.settings.imageSrc)
              );
            }
          },
        },
    }
</script>

<style lang="scss" scoped>
    .image-preview {
        width: 200px;
    }
</style>
